import * as React from "react"; // Usa l'importazione namespace
import { useNavigate } from "react-router-dom";

import Select from "react-select";
import { SaveIcon, Search } from "lucide-react";
import config from "./config";
import { getProfileFromToken } from "./config";
import MHeader from "./header";
import { useEffect } from "react";
import Mfooter from "./footer";

function AddVal({ user }) {
    const customStyles = {
      control: (base) => ({
        ...base,
        width: "80%",  // Cambia larghezza
        minHeight: "40px", // Altezza minima
        fontSize: "16px",  // Dimensione testo
      }),
    };

  const navigate = useNavigate();

  // --- Guardia per la rotta Admin ---
  React.useEffect(() => {
    let profile = getProfileFromToken();
    if (profile !== "Admin") {
      navigate("/");
    }
  }, [navigate]);

  // --- Stato per i campi del nuovo InfoVal (Valore) ---
  const [nome, setNome] = React.useState('');
  const [valore, setValore] = React.useState('');
  const [provenienza, setProvenienza] = React.useState('');
  const [datainserimento, setDataInserimento] = React.useState('');

  // --- Stato per la Dropdown dei BIMInfo ---
  const [bimInfoList, setBimInfoList] = React.useState([]); // Array di oggetti
  const [selectedBimInfo, setSelectedBimInfo] = React.useState(''); // L'ID scelto
  const [isLoading, setIsLoading] = React.useState(true);

  // --- Carica i BIMInfo per la dropdown all'avvio ---
  useEffect(() => {
    
     fetch(config.apiUrl+"/biminfo")
      .then((res) => res.json())
      .then((data) => setBimInfoList(data))
      .catch((error) => console.error("Errore nel fetch dei luoghi:", error))
  }, []); // L'array vuoto [] significa "esegui solo al montaggio"


  // --- Gestione Invio Form ---
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedBimInfo) {
      alert("Per favore, seleziona una Informazione.");
      return;
    }

    const formData = new FormData();
    formData.append('idbiminfo', selectedBimInfo.value); // Associa all'ID del biminfo
    formData.append('nome', nome);
    formData.append('valore', valore);
    formData.append('provenienza', provenienza);
    formData.append('datainserimento', datainserimento);

    try {
      // Assumo un endpoint API '/newinfoval'
      const response = await fetch(config.apiUrl + '/newinfoval', {
        method: 'POST',
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        body: formData,
      });

      if (response.ok) {
        alert(`Valore (InfoVal) aggiunto con successo!`);
        navigate("/"); // Ritorna alla home
      } else {
        alert('Errore during il salvataggio del valore.');
      }
    } catch (error) {
      console.error('Errore:', error);
      alert('Si è verificato un errore during il salvataggio.');
    }
  };

  // Stili
 

  return (
    <div className="App"> 
        <h2  className="App-header">{config.appName}</h2>
      <MHeader />
      <p ><small>utente: {user}</small></p>
      
      <h2>Aggiungi Valore (InfoVal) a Informazione</h2>
      
      <form onSubmit={handleSubmit}>
        
        {/* Selezione Info BIM */}
        <div>
          <label>Associa a Informazione:</label>
         <Select
            options={bimInfoList}
            value={selectedBimInfo}
            onChange={setSelectedBimInfo}
            placeholder="Seleziona un Info.."
            isClearable
          />
        <Search  size={1} />

        </div>

        {/* Nome */}
         <div style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0', borderRadius: '8px' }}>
          <label >Nome (es. Trasmittanza Termica):</label><p></p>
          <input
            
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />
       

        {/* Valore */}
          <p></p><label>Valore (es. 0.25 W/m²K):</label><p></p>
          <input
            type="text"
            value={valore}
            onChange={(e) => setValore(e.target.value)}
            required
          />

        {/* Provenienza */}
        
          <p></p><label >Provenienza (es. Produttore, Calcolo):</label><p></p>
          <input
            type="text"
            value={provenienza}
            onChange={(e) => setProvenienza(e.target.value)}
          />
        
        
        {/* Data Inserimento */}
       
         <p></p> <label >Data Inserimento:</label><p></p>
          <input
            type="date"
            value={datainserimento}
            onChange={(e) => setDataInserimento(e.target.value)}
          />
        <p></p><button type="submit" ><SaveIcon className="mr-2" /><br/>Salva Valore</button>
        </div>
        
      </form>
      
      <Mfooter/>
    </div>
  );
}

export default AddVal;
